import { CSSProperties, JSX, useMemo } from "react"
import { AnimalInfo } from "../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall"
import { FeedCurve } from "../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall"
import { AnimalGroupInfo } from "../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalGroupCall"
import { System } from "../Services/Agrisys_GqlDataCaller/SystemCalls/GQLCalls/getSystemCall"
import { MilestoneInfo } from "../Services/Agrisys_GqlDataCaller/MilestoneDataCalls/GQLCalls/getMilestonesCall"

export enum ListData_ValueTypes {
  Id = "Id",
  Div = "Div",
  Check = "Check",
  Number = "Number",
  String = "String",
  ProgressBar = "ProgressBar",
  List = "List",
  CreatableList = "CreatableList",
  DeleteRowAction ="DeleteRowAction",
  SelectRowAction = "SelectRowAction",
  Button = "Button",
  Display = "Display"
}

export interface SelectFieldOption_Values {
  id?: number|string
  label: string
  domain?:string
  style?: CSSProperties
  icon?: JSX.Element
}

export interface DataValue {
  type?:  ListData_ValueTypes,
  value: string|number|boolean|any //TODO: Sorter virker kun når any eksisterer (Only for the old way)
  style?:CSSProperties,
  static?:boolean,
  select?:SelectFieldOption_Values[],
}
export type DataValue_Keys = keyof DataValue
export type Data = DataValue[]
export type ValueEdit = {row: number, col: number, value: any, key: string}

export enum penTypes {
  basic="basic",
  advanced="advanced",
  simple = "simple",
  penName="penName",
  basicYesterday="basicYesterday",
  basicToday="basicToday"
}

export enum AttentionTypes {
  neutral = "Off",
  good = "Running",
  warning = "Warning",
  alert = "Alert",
}

export enum FeederStatus {
  idle="Idle",
  paused="Paused",
  dosing="Dosing",
  waiting="Waiting",
  measuring="Measuring",
  calibration="Waiting for Calibration",
  error="Error",
  off="Off"
}

export enum SystemTypes {
  AutoPig="AutoPig",
  LocationFeeder="Freeda Location Feeder",
}

export function numberConverter(data:number, format:number = 1000, padding:number = 2):string {
  var result = (Math.round(data)/format).toFixed(padding);
  return result;
}

export type Params = Partial<Pick_Arr<AnimalInfo, "animal_number">>
  & Partial<Pick_Arr<FeedCurve, "feedCurveId">>
  & Partial<Pick_Arr<AnimalGroupInfo, "animalGroupId">>
  & Partial<Pick_Arr<System, "systemId">>
  & Partial<Pick_Arr<MilestoneInfo, "milestone_id">>
// key: "" as keyof FilterParameter, value: []

export const labelToKeyMap: Record<string, Extract<keyof Params, string>> = {
  animal_number: "animal_number",
  feedCurve: "feedCurveId",
  group: "animalGroupId",
  system: "systemId",
  milestone_id: "milestone_id"
};

export function getLabelFromKey(key: string): string | undefined {
  return Object.entries(labelToKeyMap).find(([_, value]) => value === key)?.[0];
}

export type ValueType = {
  label: string
  id: number
}

export type QuickEntry = {
  key:Extract<keyof Params, string>,
  value:ValueType[]
}

export type quickEntryChange = {
    key:Extract<keyof Params, string>, 
    value:any
}

export type DataObj = Extract<keyof Params, string>

export interface ReportData {
  reportId?: number
  name?: string
  archived?: boolean,
  startDate?: number,
  endDate?: number,
  dataLevel?: DataObj
  filterParameter?: QuickEntry[][]
  dataParameter?: DataObj[]
}

export type ReportTemplate = {
  templateId?: number
  name?: string
  dataLevel?: DataObj
  filterParameter?: QuickEntry[][]
  dataParameter?: DataObj[]
}